const awsWeb = {
  aws_project_region: process.env.VUE_APP_AWS_REGION, // (optional) Default region for project
  aws_user_pools_id: process.env.VUE_APP_AWS_USER_POOLS_ID, // (optional) -  Amazon Cognito User Pool ID
  aws_cognito_identity_pool_id: process.env.VUE_APP_AWS_COGNITO_IDENTITY_POOL_ID, // (optional) - Amazon Cognito Identity Pool ID
  aws_user_pools_web_client_id: process.env.VUE_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  oauth: {},
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.VUE_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    // REQUIRED - Amazon Cognito Region
    region: process.env.VUE_APP_AWS_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_AWS_USER_POOLS_ID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_AWS_USER_POOLS_WEB_CLIENT_ID
  }
};

export default awsWeb;
